import React from "react";

const PRESTIGE_LABELS = ["Base", "Notable", "Top Tier"];
const CLASSIFICATION_LABELS = { trade: "Trade", podcast: "Podcast" };
const CLASSIFICATION_COLORS = { trade: "#b8860b", podcast: "#6f42c1" };

function daColor(score) {
  if (score == null) return "";
  if (score >= 70) return "#5a9a68";
  if (score >= 30) return "#9a8a5a";
  return "#9a6a5a";
}

function prestigeStars(prestige) {
  if (prestige == null || prestige <= 0) return null;
  return "\u2605".repeat(prestige);
}

function OutletRating({ prestige, domainAuthority, outletClassification, variant = "small" }) {
  const hasStars = prestige != null && prestige > 0;
  const hasPrestige = prestige != null;
  const hasDA = domainAuthority != null;
  const classLabel = CLASSIFICATION_LABELS[outletClassification];
  const classColor = CLASSIFICATION_COLORS[outletClassification];

  if (variant === "large") {
    if (!hasPrestige && !hasDA && !classLabel) return null;
    return (
      <>
        {classLabel && (
          <div className="d-flex justify-content-between small mb-1">
            <span className="text-muted">Classification</span>
            <span className="badge" style={{ backgroundColor: classColor }}>
              {classLabel}
            </span>
          </div>
        )}
        {hasPrestige && (
          <div className="d-flex justify-content-between small mb-1">
            <span className="text-muted">Prestige</span>
            <strong>
              {PRESTIGE_LABELS[prestige]}
              {hasStars && <span className="ms-1">{prestigeStars(prestige)}</span>}
            </strong>
          </div>
        )}
        {hasDA && (
          <div className="d-flex justify-content-between small mb-1">
            <span className="text-muted">Domain Authority</span>
            <strong style={{ color: daColor(domainAuthority) }}>{domainAuthority}</strong>
          </div>
        )}
      </>
    );
  }

  // Small variant (default) — compact inline, stars only (no "Base" label)
  if (!hasStars && !hasDA && !classLabel) return null;
  return (
    <span className="text-muted small">
      {classLabel && (
        <span className="badge me-1" style={{ fontSize: "0.7em", backgroundColor: classColor }}>
          {classLabel}
        </span>
      )}
      {hasStars && (
        <span className="me-1" title={PRESTIGE_LABELS[prestige]}>
          {prestigeStars(prestige)}
        </span>
      )}
      {hasDA && (
        <span style={{ fontWeight: 600, color: daColor(domainAuthority) }} title="Moz Domain Authority">
          DA: {domainAuthority}
        </span>
      )}
    </span>
  );
}

export { daColor, PRESTIGE_LABELS };
export default OutletRating;
